import React from 'react';
import PropTypes from 'prop-types';
import { DefaultButtonShim, PrimaryButtonShim, MenuButtonShim, CompoundButtonShim } from '@fluentui/react-migration-v8-v9';
import { SplitButtonShim } from './split-button-shim';
import { CommandButton } from './action-button-shim';

const PrimaryButtonInternal = (props) => {
  const {
    split, menuProps, className, ...rest
  } = props;

  if (split) {
    return (
      <SplitButtonShim primary className={className} {...rest} />
    );
  }

  if (menuProps) {
    return (
      <MenuButtonShim primary className={className} {...rest} />
    );
  }
  return (
    <PrimaryButtonShim className={className} primary {...rest} />
  );
};


PrimaryButtonInternal.propTypes = {
  split: PropTypes.bool,
  className: PropTypes.string,
  menuProps: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      iconProps: PropTypes.shape({
        iconName: PropTypes.string.isRequired,
      }),
    })),
  }),
};

PrimaryButtonInternal.defaultProps = {
  split: false,
  menuProps: undefined,
  className: undefined,
};


const DefaultButtonInternal = (props) => {
  if (props.split) {
    return (
      <SplitButtonShim {...props} />
    );
  }

  if (props.menuProps) {
    return (
      <MenuButtonShim {...props} />
    );
  }

  return (
    <DefaultButtonShim {...props} />
  );
};

DefaultButtonInternal.propTypes = {
  split: PropTypes.bool,
  menuProps: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      iconProps: PropTypes.shape({
        iconName: PropTypes.string.isRequired,
      }),
    })),
  }),
};

DefaultButtonInternal.defaultProps = {
  split: false,
  menuProps: undefined,
};

const CompoundButtonInternal = props => (
  <CompoundButtonShim {...props} />
);

const IconButtonInternal = props => (
  <CommandButton {...props} />
);


export const PrimaryButton = PrimaryButtonInternal;
export const IconButton = IconButtonInternal;
export const CompountButton = CompoundButtonInternal;
export const DefaultButton = DefaultButtonInternal;
